import { ApiError } from "./api";

/** The server's message for a failed request (e.g. "Letterman není dostupný"), else the fallback. */
export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const body = err.body as { message?: string } | null;
    if (body?.message) return body.message;
  }
  return fallback;
}
